

import { signInWithGoogle, signInWithFacebook, signInWithApple } from "@/helpers/firebase/auth";
import { startLoader, stopLoader } from "@/redux/features/app-slice";
import { AppDispatch } from "@/redux/store";
import router from "next/router";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import Image from "next/image";

// import { redirect, useRouter } from 'next/navigation';

export default function LoginViaSocialMedia() {
  const dispatch = useDispatch<AppDispatch>();
  // const router = useRouter();


  const handleLogInWithGoogle = async () => {
    dispatch(startLoader(""));
    await signInWithGoogle();
    dispatch(stopLoader());
  };

  const handleLogInWithApple = async () => {
    dispatch(startLoader(""));
    await signInWithApple();
    dispatch(stopLoader());
  };

  const handleLogInWithFacebook = () => {
    signInWithFacebook()
  };



  const loginWithLinkedIn = () => {
    const state = generateRandomStringForState();
    const origin = window.location.origin;

    const params = new URLSearchParams({
      response_type: 'code',
      client_id: process.env.NEXT_PUBLIC_LINKEDIN_CLIENT_ID || '',
      redirect_uri: `${origin}/api/linkedin`,
      scope: 'email openid profile',
      state: state
    });

    const authUrl = `https://www.linkedin.com/oauth/v2/authorization?${params.toString()}`;
    window.location.href = authUrl;
  };

  const generateRandomStringForState = () => {
    const randomString = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    return randomString;
  }

  return (
    <>
      <div className="my-2 flex items-center before:mt-0.5 before:flex-1 before:border-t before:border-custom-gray after:mt-0.5 after:flex-1 after:border-t after:border-custom-gray">
        <p className="mx-2 mt-1 text-center font-medium leading-4 text-custom-gray text-xs">
          OR
        </p>
      </div>

      <div className="p-4 flex justify-center space-x-2 mb-6">
        <div className="flex space-x-6">

          <button
            onClick={handleLogInWithGoogle}
            className="flex items-center justify-center  h-[3.813rem] w-[3.813rem] bg-white rounded-[0.625rem] px-4 py-2"
          >
            <Image
              height={23}
              width={23}
              alt="google icon"
              src={"/images/Google_icon.svg"}
            />
          </button>

          <button
            onClick={handleLogInWithApple}
            className="flex items-center justify-center h-[3.813rem] w-[3.813rem] bg-white rounded-[0.625rem] px-4 py-2"
          >
            <Image
              height={23}
              width={23}
              alt="google icon"
              src={"/images/Apple_icon.svg"}
            />

          </button>


          <button
            onClick={handleLogInWithFacebook}
            className="flex items-center justify-center bg-white h-[3.813rem] w-[3.813rem] rounded-[0.625rem] px-4 py-2"
          >
            <Image
              height={23}
              width={23}
              alt="google icon"
              src={"/images/Facebook_icon.svg"}
            />

          </button>

          <button
            onClick={loginWithLinkedIn}
            className="flex items-center justify-center bg-white  h-[3.813rem] w-[3.813rem] rounded-[0.625rem] px-4 py-2">
            <Image
              height={23}
              width={23}
              alt="google icon"
              src={"/images/LinkedIn_icon.svg"}
            />

          </button>
        </div>
      </div>
    </>
  );
}
